module.exports = __webpack_public_path__ + "img/leica-logo.52a93bf7.png";